<div class="row" style="padding: 9px;min-height: 405px;">

    <div class="body table-responsive">
        <table class="table">
            <thead>
                <tr>
                    <th colspan="12">
                        <div class="row mt-1" style="padding: 5px;">
                            <div
                                class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                                <label>Type de remboursement :
                                </label>
                                <ng-select name="type_remboursement_id" [(ngModel)]="defaultValues.type_remboursement_id"
                            placeholder="Choisissez "
                            id="type_remboursement_id" [multiple]="false"
                            [closeOnSelect]="true">
                            <ng-option (ngModelChange)="onInputChange($event)" [clearable]="false" *ngFor="let item of itemsTypeRemboursement"
                                [value]="item.id">{{
                                item?.libelle }}
                            </ng-option>
                        </ng-select>
                            </div>
                            <div
                                class="col-xl-2 col-lg-2 col-md-2 col-sm-2 mb-1 select-container">
                                <label>Plafond police :
                                </label>
                                <input [(ngModel)]="defaultValues.plafond_police"
                                    name="plafond_police" type="text" mask="separator"
                                    class="form-control">
                            </div>
                            <div
                                class="col-xl-2 col-lg-2 col-md-2 col-sm-2 mb-1 select-container">
                                <label>Plafond collège :
                                </label>
                                <input [(ngModel)]="defaultValues.plafond_college"
                                    name="plafond_college" type="text" mask="separator"
                                    class="form-control">
                            </div>
                            <div
                                class="col-xl-2 col-lg-2 col-md-2 col-sm-2 mb-1 select-container">
                                <label>Plafond famille :
                                </label>
                                <input [(ngModel)]="defaultValues.plafond_famille"
                                    name="plafond_famille" type="text" mask="separator"
                                    class="form-control">
                            </div>
                            <div
                                class="col-xl-2 col-lg-2 col-md-2 col-sm-2 mb-1 select-container">
                                <label>Plafond individuel :
                                </label>
                                <input [(ngModel)]="defaultValues.plafond_individuel"
                                    name="plafond_individuel" type="text"
                                    mask="separator" class="form-control">
                            </div>

                            <div class="col-md-2">
                                <br>
                                <button type="button" class="btn custom_btn_primary"
                                    (click)="setDefautValuesGarantie()"> <i
                                        class="fa fa-fill"></i>Remplir</button>
                            </div>

                        </div>
                    </th>
                </tr>
                <tr class="custom-table-head">
                    <th style="width: 5px;">
                        <input [(ngModel)]="is_all_checked" name="is_all_checked"
                            (change)="onSelectAllRow($event)" type="checkbox">
                        <a style="cursor: pointer" (click)="currentPage = 0; getItems()"
                            title="Actualiser">
                            <i class="fa fa-redo-alt"></i></a>&nbsp;&nbsp; #
                    </th>
                    <th>Codification</th>
                    <th>Libellé</th>
                    <th style="width: 20%;">Type remboursement</th>
                    <th>Plafond police</th>
                    <th>Plafond collège</th>
                    <th>Plafond famille</th>
                    <th>Plafond individuel</th>
                    <!-- <th class="txt-align-center">Actions</th> -->
                </tr>
            </thead>
            <tbody>
                <tr style="cursor: pointer;"
                    *ngFor="let item of items; let indice = index"
                    (click)="currentRow = item">
                    <!-- <td class="txt-align-center">{{ currentPage>1?(((currentPage - 1) * this.itemsPerPage) + (indice+1)):indice+1 }}</td> -->
                    <td class="txt-align-center">
                        <!-- <input name="is_checked" (change)="onSelectRow()" type="checkbox" [(ngModel)]="item.is_checked"> -->
                        <!-- {{item.is_checked}} -->
                        <!-- <input [(ngModel)]="item.is_checked" name="is_checked" (change)="onSelectRow()" type="checkbox" > -->
                        <input [ngModelOptions]="{standalone: true}"
                            [(ngModel)]="item.is_checked"
                            (change)="onSelectRow(item,$event)" type="checkbox">
                    </td>
                    <td>{{ item?.codification}}</td>
                    <td>{{ item?.libelle}}</td>
                    <td>
                        
                        <ng-select (change)="onInputChange($event)" [ngModelOptions]="{standalone: true}" [(ngModel)]="item.type_remboursement_id"
                            placeholder="Choisissez "
                            [multiple]="false"
                            [closeOnSelect]="true">
                            <ng-option [clearable]="false" *ngFor="let item_remb of itemsTypeRemboursement"
                                [value]="item_remb.id">{{
                                item_remb?.libelle }}
                            </ng-option>
                        </ng-select>
                    </td>
                    <td><input [ngModelOptions]="{standalone: true}"
                            [(ngModel)]="item.plafond_police" type="text"
                            mask="separator" class="form-control"></td>
                    <td><input [ngModelOptions]="{standalone: true}"
                            [(ngModel)]="item.plafond_college" type="text"
                            mask="separator" class="form-control"></td>
                    <td><input (input)="onInputChange($event)" [ngModelOptions]="{standalone: true}"
                            [(ngModel)]="item.plafond_famille" type="text"
                            mask="separator" class="form-control"></td>
                    <td><input (input)="onInputChange($event)" [ngModelOptions]="{standalone: true}"
                            [(ngModel)]="item.plafond_individuel" type="text"
                            mask="separator" class="form-control"></td>
                    <!-- <td>
                            <div class="custom-td-action">
                                <a title="Supprimer" (click)="items.splice(indice,1)"
                                    class="custom-btn-delete">
                                    <i class="fa fa-trash"></i></a>
                            </div>
                        </td> -->
                </tr>
            </tbody>

            <tfoot>
                <tr *ngIf="items && items.length > 0">
                    <td colspan="12">
                        <div class="row pagination-part">
                            <div class="col-md-9" style="text-align: center">
                                <pagination [ngModelOptions]="{standalone: true}"
                                    [maxSize]="5" [boundaryLinks]="true"
                                    [itemsPerPage]="itemsPerPage"
                                    [totalItems]="totalItems" [(ngModel)]="currentPage"
                                    class="pagination-sm" previousText="&lsaquo;"
                                    nextText="&rsaquo;" firstText="&laquo;"
                                    lastText="&raquo;"
                                    (pageChanged)="pageChanged($event)">
                                </pagination>
                            </div>

                            <div class="col-md-3">
                                <div class="paginator-per-page">
                                    <app-element-by-page-paginator (paginationChange)="
                changePaginationSize($event)
              " [defaultItemPerPage]="itemsPerPage">
                                    </app-element-by-page-paginator>

                                    <span class="span_total_entree pull-right">Total :
                                        {{ totalItems
                                        }}</span>
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>

                <tr *ngIf="!items || items.length == 0">
                    <td colspan="12">
                        <div class="col-md-12 txt-align-center">
                            Aucune donnée disponible
                        </div>
                    </td>
                </tr>
            </tfoot>
        </table>
    </div>
</div>